import React from "react";
import PricingCard from "./PricingCard";

interface PricingPackageProps {
    packages: any;
    packageHandler: any
    isLoading?: boolean
    packagesUnavailable?: boolean
}


const PricingPackage: React.FC<PricingPackageProps> = ({
    packages,
    packageHandler,
    isLoading,
    packagesUnavailable
}) => {
    return (
        <div id="pricing_packages" className="lg:bg-[#F5F6F7] pt-[45px] lg:pt-[80px] pb-[85px]">
            <h2 className="hidden lg:block text-center mb-4 text-[48px] font-semibold">Pricing packages</h2>
            <p className="text-center w-[54%] mx-auto mb-10 hidden lg:block">Stop wasting time with mismatched candidates. Talent Hub's video CVs and detailed profiles help you
                quickly identify top talent that aligns perfectly with your clients' needs.</p>
            <div className="flex flex-col lg:flex-row w-[90%] md:w-[54%] items-center lg:justify-between mx-auto">
                {packagesUnavailable ? (
                    <p className="text-center w-full">Pricing is temporarily unavailable. Please try again later.</p>
                ) : packages?.map((item: any, index: number) => {
                    return <PricingCard
                        {...item}
                        index={index}
                        key={index}
                        packageHandler={packageHandler}
                        isLoading={isLoading}
                    />
                })}

            </div>
        </div>
    )
}

export default PricingPackage;